const defaultBoxes = [];
const boxNotes = (state = defaultBoxes, action) => {
  switch (action.type) {
    case 'GET_NOTE_SUCCESS':
      return action.boxNotes;
    default:
      return state;
  }
};

export default boxNotes;